import React from 'react';
import PropTypes from 'prop-types';
import TweenOne from 'rc-tween-one';
import ScrollOverPack from 'rc-scroll-anim/lib/ScrollOverPack';
import {Col, Row} from 'antd';
import QueueAnim from 'rc-queue-anim';
import {Link} from "react-router-dom";

export default function Page3({isMobile}) {
    return (
        <ScrollOverPack id="page3" className="content-wrapper page">
            <Row justify='center'>
                <Col className='page-box' xs={20} sm={16} md={12} lg={11} xl={11}>
                    <TweenOne
                        key="image"
                        className="image3 image-wrapper"
                        animation={{x: 0, opacity: 1, ease: 'easeOutQuad'}}
                        style={{transform: 'translateX(-100px)', opacity: 0}}
                    />
                </Col>
                <Col className='page-box' xs={20} sm={16} md={12} lg={11} xl={11}>
                    <QueueAnim
                        className="text-wrapper mobile-style"
                        key="text"
                        type={isMobile ? 'bottom' : 'right'}
                        leaveReverse
                        style={{top: '40%'}}
                    >
                        <h2 key="h2">多样载荷，任您选择</h2>
                        <p key="p">
                            我们提供的载荷模块经过重新设计，可以实现快速换装，满足不同的需求。目前已有光电吊舱、正射相机、倾斜相机、多光谱相机以及激光雷达。
                        </p>
                        <p className='learn-more-aircraft'><Link to="/payload">了解更多</Link></p>
                    </QueueAnim>
                </Col>
            </Row>
        </ScrollOverPack>
    );
}
Page3.propTypes = {
    isMobile: PropTypes.bool,
};
